export default "__VITE_ASSET__CNFS8jEI__"